import fieldValidation from './booking/field.validation';
import popover from './booking/popover';
import priceChange from './booking/price.change';
import trainSelection from './booking/train.selection';
import venueInput from './booking/venue.input';

$(document).ready(function () {
    fieldValidation();
    priceChange();
    trainSelection();
    venueInput();
})